import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { DebugLoggerService } from '../../../services/debug-logger.service';
import { AppStateHolder } from '../../../shared';
import { LastUsedService } from './last-used.service';

@Component({
    selector: 'templates-last-used',
    templateUrl: 'last-used.component.html',
    styleUrls: ['./last-used.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})

export class LastUsedTemplatesComponent implements OnInit, OnDestroy {
  appStateHolder = inject(AppStateHolder);
  private service = inject(LastUsedService);
  private _debugLogger = inject(DebugLoggerService);

  @Input() modify: Boolean;
  @Input() border: Boolean;

  @Input() widgetPosition: any;

  openOptions: boolean = false;
  lastTemplates: any[];

  requestsSubscribe: Subscription;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  ngOnInit(): void {
    this._debugLogger.logLifecycle('LastUsedTemplates', 'ngOnInit');
    if (!this.modify) {
      this.requestsSubscribe = this.service.getLastUsed()
        .subscribe(result => {
          this._debugLogger.logAction('LastUsedTemplates', 'templates loaded', { count: result?.length });
          this.lastTemplates = result;
        });
    }
  }

  options() {
    this.openOptions = !this.openOptions;
  }

  hasLastTemplates(): Boolean {
    if (this.lastTemplates === undefined)
      return false;

    return (this.lastTemplates && this.lastTemplates.length > 0);
  }

  ngOnDestroy(): void {
    if (this.requestsSubscribe)
      this.requestsSubscribe.unsubscribe()
  }
}
